export interface RecordingController {
    stop(): Promise<{ blob: Blob, url: string, mimeType: string }>;
}

export function startRecording(stream: MediaStream, preferredTypes: string[] = [
    'video/webm;codecs=vp9',
    'video/webm;codecs=vp8',
    'video/webm',
    'video/mp4',
]): RecordingController | null {
    // @ts-ignore
    const hasMediaRecorder = typeof MediaRecorder !== 'undefined';
    if (!hasMediaRecorder) return null;

    let mimeType: string | undefined;
    // @ts-ignore
    if (typeof MediaRecorder.isTypeSupported === 'function') {
        for (const type of preferredTypes) {
            // @ts-ignore
            if (MediaRecorder.isTypeSupported(type)) { mimeType = type; break; }
        }
    }

    let recorder: MediaRecorder;
    try {
        // @ts-ignore
        recorder = new MediaRecorder(stream, mimeType ? { mimeType } : undefined);
    } catch (e) {
        return null;
    }

    const chunks: Blob[] = [];
    recorder.ondataavailable = (ev: any) => {
        if (ev.data && ev.data.size > 0) chunks.push(ev.data);
    };

    try { recorder.start(100); } catch {}

    return {
        async stop() {
            if (recorder.state !== 'inactive') {
                try { recorder.stop(); } catch {}
            }
            await new Promise<void>(resolve => {
                const handler = () => resolve();
                recorder.onstop = handler;
                // Fallback timeout
                setTimeout(resolve, 500);
            });
            const blob = new Blob(chunks, { type: mimeType || 'video/webm' });
            const url = URL.createObjectURL(blob);
            return { blob, url, mimeType: mimeType || 'video/webm' };
        }
    };
}


